import 'bootstrap';

import CollapseAndDestructListener from "./custom/CollapseAndDestructListener";
import PopupListener from "./custom/PopupListener";
import CookiesAlert from "./custom/CookiesAlert";

const collapseAndDestructListener = new CollapseAndDestructListener();
const popupListener = new PopupListener();
const cookiesAlert = new CookiesAlert();